import { Anchor, AnchorProps } from '@mantine/core';
import { Link } from 'react-router-dom';

interface CustomAnchorProps extends AnchorProps {
  children: React.ReactNode | React.ReactNode[] | string,
  component?: 'a' | 'button';
  disabled?: boolean;
  onClick?: () => void;
  to?: string;
}

const CustomAnchor = ({
  children,
  component = 'a',
  disabled,
  onClick,
  to = '#',
  ...props
}: CustomAnchorProps) => (
  <Anchor
    component={Link}
    to={to}
    {...props}
    onClick={onClick}
  >
    {children}
  </Anchor>
)

export default CustomAnchor;